/**
 * Home.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import QuizSelectionSection from 'containers/QuizSelectionSection';

import Hero from 'components/Hero';
import TutorialDescription from 'components/TutorialDescription';

import quizActions from 'store/quiz/actions';

import event from 'utils/event';

import {
  HeroTitle,
  HeroSubtitle,
  HomeContainer,
  QuizSelectionButtons,
  HeroContent,
  ChooseQuizButton,
  RandomQuizButton,
  ChooseLink,
} from './Home.styles';

/**
 * The main screen that displays a question
 *
 */
export class Home extends Component {
  static propTypes = {
    getRandomQuiz: PropTypes.func.isRequired,
    goToQuiz: PropTypes.func.isRequired,
    history: PropTypes.object,
  }

  goToRandomQuiz = () => {
    const { goToQuiz, getRandomQuiz, history } = this.props;
    getRandomQuiz()
      .then((quiz) => {
        event(`click-random-quiz`, [`click`, `random-quiz`, `${quiz.id}`]);
        return goToQuiz(quiz.id);
      })
      .then((url) => {
        history.push(url);
      })
      .catch(() => { });
  }

  trackJumpToCategory = () => {
    event(`click-jump-to-category`, [`click`, `jump-to-category-section`]);
  }

  render() {
    return (
      <HomeContainer>
        <Hero>
          <HeroContent>
            <HeroTitle>
              So You Think You Can&nbsp;Trivia?
            </HeroTitle>
            <HeroSubtitle>
              Test Your Knowledge On...
            </HeroSubtitle>
            <QuizSelectionButtons>
              <ChooseLink href="/#quiz-selection">
                <ChooseQuizButton onClick={this.trackJumpToCategory} type="primary">
                  Choose a Quiz
                </ChooseQuizButton>
              </ChooseLink>
              <RandomQuizButton
                onClick={this.goToRandomQuiz}
              >
                Take me to a random Quiz
              </RandomQuizButton>
            </QuizSelectionButtons>
          </HeroContent>
        </Hero>
        <QuizSelectionSection />
        <TutorialDescription goToRandomQuiz={this.goToRandomQuiz} />
      </HomeContainer>
    );
  }
}

export default connect(null, {
  getRandomQuiz: quizActions.getRandomQuiz,
  goToQuiz: quizActions.goToQuiz,
  selectQuiz: quizActions.selectQuiz,
})(Home);
